import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { Document } from 'src/app/_models/document';

@Injectable({
   providedIn: 'root',
})
export class DocumentService {
   constructor(private http: HttpClient) {}
   baseUrl = environment.apiUrl;
   transactionReceived = new BehaviorSubject<any>('');
   tranReceived(d: any) {
      this.transactionReceived.next(d);
   }
   getDocuments(id: number, documentType: string): Observable<Document[]> {
      return this.http.get<Document[]>(this.baseUrl + 'document/' + documentType + '/' + id);
   }
   deleteDocument(id: string, docType: string) {
      return this.http.delete(this.baseUrl + 'document/' + encodeURIComponent(docType) + '/' + encodeURIComponent(id));
   }
}
